<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Formulario de Despacho y Sancion de Naves</h3>
            <h6 clas="col" align="center">UFV {{ ufv_sancion }} al {{ ufv_date }} <button class="btn btn-success" @click="callUfv"> <font-awesome-icon icon="sync-alt" size="lg" /> </button></h6>
            <table class="table">
                <tr>
                    <td align="left"><b># Reincidencia:</b> {{ penalty_dts.number_relapse }} <b>r:</b> {{penalty_dts.factor_relapse}}</td>
                    <td align="right"><b>C:</b> {{ cut_sancion.toFixed(5) }} <b>A:</b> {{ actividad_sancion.factor > 0 ? actividad_sancion.factor:0}} <b>P:</b> {{ boatLocal.factor_propulsion ? boatLocal.factor_propulsion : propulsion_sancion.factor }} <b>N:</b> {{ navegacion_sub_sancion.factor > 0 ? navegacion_sub_sancion.factor:0}}</td>
                </tr>
            </table>
            <h6 clas="col" align="right"></h6>

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link disabled" :class="[is_active_step_one_sancion ? 'active':'']" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_two_sancion ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">2. Operacion</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_tree_sancion ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">3. Carga</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_fourth_sancion ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-tirdh" role="tab" aria-controls="nav-profile" aria-selected="false">4. Resumen</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                
                <div class="tab-pane fade" :class="[is_active_step_one_sancion ? 'show active':'']" id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcacion</label>                    
                            <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-model="boatLocal.name_boat" id="enrollment_boat" placeholder="Nombre Embarcacion" :readonly="is_disabled_sancion ? true:false " autocomplete="off">
                        </div>
                        
                        <div class="form-group col-12 col-md-6">
                            <label for="matricula" class="badge badge-primary">Matricula de la Embarcacion</label>
                            <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-model="boatLocal.enrollment" name="matricula" placeholder="Matricula Embarcacion" autocomplete="off" @blur="mSearchEnroll">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera de la Embarcacion</label>
                            <input type="text" class="form-control" name="flag_ship" v-model="boatLocal.flag_boat" v-if="boatLocal.flag_boat" :readonly="global_disabled ? true:false ">
                            <select v-else class="form-control" name="bandera_embarcacion" v-model="bandera_sancion">
                                <option v-for="flag in banderas_sancion" :value="flag" :key="flag.id">{{ flag.detail }}</option>
                            </select>
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="propulsion_sancion" class="badge badge-primary">Propulsion</label>
                            <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-if="boatLocal.detail_propulsion" v-model="boatLocal.detail_propulsion">
                            <select v-else class="form-control" v-model="propulsion_sancion" name="propulsion_sancion" @change="calculateForm">
                                <option v-for="motor in propulsiones_sancion" :key="motor.id" :value="motor">{{ motor.detail }}</option>
                            </select>

                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ship_sancion" class="badge badge-primary">Tipo nave</label>
                                <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-if="boatLocal.detail_boat" v-model="boatLocal.detail_boat">
                                <select v-else class="form-control" v-model="type_boat_sancion" name="propulsion_sancion">
                                    <option v-for="boat in types_boat_sancion" :key="boat.id" :value="boat.detail">{{ boat.detail }}</option>
                                </select>
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="number" v-model="boatLocal.trb" :disabled="global_disabled ? true:false" class="form-control" name="trb" placeholder="TRB" @keyup="calculateForm" autocomplete="off">
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label for="trb" class="badge badge-primary">TRN</label>
                            <input type="number" v-model="boatLocal.trn" :disabled="global_disabled ? true:false" class="form-control" name="trb" placeholder="TRN" autocomplete="off">
                        </div>
                    </div>                    

                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end first tab traffic -->

                <div class="tab-pane fade" :class="[is_active_step_two_sancion ? 'show active':'']" id="nav-second" role="tabpanel" aria-labelledby="nav-profile-tab">
                    

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="captain" class="badge badge-primary">Capitan de la nave</label>
                            <input type="text" class="form-control" autocomplete="off" v-model="capitan_ship_sancion" placeholder="Capitan de la Nave">
                            
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="tipo_navegacion" class="badge badge-primary">Despacho de Nave</label>
                            <select class="form-control" v-model="navegacion_sancion" name="tipo_navegacion" @change="callNavDet">
                                <option v-for="navigate in navegaciones_sancion" :value="navigate" :key="navigate.id">{{ navigate.detail }} </option>
                            </select>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                    <div v-if="state_navigation_sub_sancion">
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="navegacion_detalle" class="badge badge-info">Tipo de Navegacion</label>
                                <select class="form-control" v-model="navegacion_sub_sancion" name="navegacion_detalle" @change="calculateForm">
                                    <option v-for="n_detail in navegaciones_sub_sancion" :key="n_detail.id" :value="n_detail" >{{ n_detail.detail }}</option>
                                </select>
                            </div>
                                    
                            <div class="form-group col-12 col-md-6">
                                <label for="fecha_despacho" class="badge badge-info">Fecha de {{ type_navigate_sancion }}</label>
                                <datetime v-model="date_office_sancion" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                <!-- <input type="date" class="form-control" v-model="date_office_sancion" name="fecha_despacho" placeholder="Fecha" autocomplete="off"> -->
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="puerto_origen" class="badge badge-info">Puerto de Origen</label>
                                <select v-if="port_begin_sancion.disabled" name="port_begin_select" class="form-control" v-model="port_select_begin_sancion">
                                    <option v-for="p in ports_registers_captain_sancion" :key="p.id" :value="p">{{ p.description }}</option>
                                </select>

                                <vue-bootstrap-typeahead                                        
                                        v-model="port_query_sancion"
                                        :data="portsRegisterSancion"
                                        :serializer="item => item.portDetail"
                                        @hit="mSelectedPort"
                                        :placeholder="placeholder_port_sancion"
                                        v-else
                                    />
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="puerto_destino" class="badge badge-info">Puerto de Destino</label>
                                <select v-if="port_finish_sancion.disabled" name="port_begin_select" class="form-control" v-model="port_select_finish_sancion">
                                    <option v-for="p in ports_registers_captain_sancion" :key="p.id" :value="p">{{ p.description }}</option>
                                </select>
                                <vue-bootstrap-typeahead                                        
                                        v-model="port_query_sancion"
                                        :data="portsRegisterSancion"
                                        :serializer="item => item.portDetail"
                                        @hit="mSelectedPort"
                                        :placeholder="placeholder_port_sancion"
                                        v-else
                                    />
                            </div>
                        </div>
                    </div>
                    </transition>
                    
                    <div class="form-row">
                        <button class="btn btn-outline-danger col-6 col-md-4 offset-md-2" @click="fBack">
                            <font-awesome-icon icon="chevron-circle-left" size="lg" />
                        </button>
                        <button class="btn btn-outline-warning col-6 col-md-4" @click="fNext">
                            <font-awesome-icon icon="chevron-circle-right" size="lg" />
                        </button>
                    </div>
                </div>
                <!-- end second tab -->

            <div class="tab-pane fade" :class="[is_active_step_tree_sancion ? 'show active':'']" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_load" class="badge badge-primary">Detalle Carga o Servicio</label>
                            <vue-bootstrap-typeahead                                        
                                        v-model="load_query_sancion"
                                        :data="loads_type_sancion"
                                        :serializer="item => item.carga_detail"
                                        @hit="mSelectLoad"
                                        :placeholder="dPlaceLoadSancion"
                                    />
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="actividad_sancion" class="badge badge-primary">Tipo de servicio</label>
                                <input class="form-control" type="text" disabled="disabled" v-model="aux_activity_sancion.service" />
                        </div>
                </div>
                        <transition name="fade" mode="out-in">
                        <div v-if="c_efectiva_passenger_sancion">
                            <h6><span class="badge badge-primary">Cantidad Pasajeros</span></h6>
                            <div class="row">
                            <div class="col-12 col-md-6">
                                <h6><span class="badge badge-success">Bolivianos</span></h6>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                    </div>
                                    <input type="number" v-model="national_men_sancion" class="form-control" aria-label="Default" placeholder="0" aria-describedby="inputGroup-sizing-default">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                    </div>
                                    <input type="number" class="form-control" v-model="national_women_sancion" aria-label="Default" placeholder="0" aria-describedby="inputGroup-sizing-default">
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <h6><span class="badge badge-success">Extranjeros</span></h6>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                    </div>
                                    <input type="number" v-model="foreign_men_sancion" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="0">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                    </div>
                                    <input type="number" v-model="foreign_women_sancion" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="0">
                                </div>
                            </div>
                            </div>
                        </div>
                        </transition>
                        


                        <transition name="fade" mode="out-in">
                            <div v-if="c_efectiva_load_kilo_sancion">                  

                            <div class="form-row">
                                
                                <div class="form-group col-12 col-md-8">
                                    <div class="row">
                                        
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_kilo_sancion" class="badge badge-info">Kilos</label>
                                            <input type="number" v-model="load_cash_kilo_sancion" @keyup="calcKiloTonelada" class="form-control" aria-label="Default" placeholder="Kilos" aria-describedby="inputGroup-sizing-default">    
                                        </div>
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_tonelada_sancion" class="badge badge-info">Toneladas</label>
                                            <input type="number" v-model="load_cash_tonelada_sancion" @keyup="calcToneladaKilo" class="form-control" aria-label="Default" placeholder="Toneladas" aria-describedby="inputGroup-sizing-default">
                                        </div>
                                    </div>                                    
                                </div>

                                <transition name="fade" mode="out-in">
                                        <div class="form-group col-12 col-md-4" v-if="c_efectiva_load_rodada_sancion">
                                            <label for="load_quantity" class="badge badge-info">Cantidad</label>
                                            <input type="number" v-model="c_quantity_sancion" class="form-control" placeholder="Cantidad" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                        </div>
                                </transition>
                            </div>
                            
                            </div>
                        </transition>

                        <transition name="fade" mode="out-in">
                            <div v-if="c_efectiva_load_litro_sancion">                  

                            <div class="form-row">
                                <div class="form-group col-12 col-md-4">
                                    <label for="load_cash_kilo_sancion" class="badge badge-info">Liquido (litros)</label>
                                    <input type="number" v-model="load_cash_litro_sancion" class="form-control" placeholder="Litros" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                </div>
                            </div>
                            </div>
                        </transition>

                        <transition name="fade" mmode="out-in">
                            <div v-if="is_dredge_sancion">
                                <div class="form-row">
                                    <div class="form-group col-12 col-md-4">
                                        <label for="load_cash_kilo_sancion" class="badge badge-danger">Dias de Trabajo</label>
                                        <input type="number" v-model="job_days_sancion" class="form-control" placeholder="Dias de Trabajo" aria-label="Default" aria-describedby="inputGroup-sizing-default" @change="calculateForm">
                                    </div>
                                    <div class="form-group col-12 col-md-3">
                                        <label for="date_init_ordop" class="badge badge-danger">Fecha Zarpe <span class="required-text">*</span></label>
                                        <datetime v-model="date_init_oper_aux_sancion" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                        <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                                    </div>
                                    <div class="form-group col-12 col-md-3">
                                        <label for="time_init_ordop" class="badge badge-danger">Fecha Arribo <span class="required-text">*</span></label>
                                        <datetime v-model="date_end_oper_aux_sancion" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                        <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                                    </div>

                                </div>
                            </div>
                        </transition>

                    <div class="form-row">
                        <button class="btn btn-outline-danger col-6 col-md-4 offset-md-2" @click="fBack">
                            <font-awesome-icon icon="chevron-circle-left" size="lg" />
                        </button>
                        <button class="btn btn-outline-warning col-6 col-md-4" @click="fNext">
                            <font-awesome-icon icon="chevron-circle-right" size="lg" />
                        </button>
                    </div>

            </div>
            <!-- end tirdth tab -->

            <div class="tab-pane fade" :class="[is_active_step_fourth_sancion ? 'show active':'']" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">

                    <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="actividad_sancion" class="badge badge-success">Nombre Embarcacion</label>
                                <p class="text-uppercase" v-if="boatLocal.name_boat">{{ boatLocal.name_boat }}</p>
                                <p class="text-uppercase" v-else>--Sin datos--</p>
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="load_cash_kilo_sancion" class="badge badge-success">TRB</label>
                                <p class="text-uppercase" v-if="boatLocal.trb">{{ boatLocal.trb }}</p>
                                <p class="text-uppercase" v-else>--Sin datos--</p>
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="load_cash_litro_sancion" class="badge badge-success">Propulsion</label>
                                <p class="text-uppercase" v-if="boatLocal.detail_propulsion">{{ boatLocal.detail_propulsion }}</p>
                                <p class="text-uppercase" v-else-if="propulsion_sancion.detail">{{ propulsion_sancion.detail }}</p>
                                <p class="text-uppercase" v-else>--Sin datos--</p>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="actividad_sancion" class="badge badge-success">Tipo Despache</label>
                                <p class="text-uppercase" v-if="type_navigate_sancion">{{ type_navigate_sancion }}</p>
                                <p class="text-uppercase" v-else>--Sin Datos--</p>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="actividad_sancion" class="badge badge-success">Servicio</label>
                                <p class="text-uppercase" v-if="navegacion_sub_sancion">{{ navegacion_sub_sancion.detail }}</p>
                                <p class="text-uppercase" v-else>-- Sin datos --</p>
                            </div>
                        </div>

                    <div class="form-row">
                        <div class="form-group col-6 col-md-6">
                            <label for="total_importe" class="badge badge-primary">Importe Individual Bs.</label>
                            <input type="text" class="form-control" name="total_importe" v-model="total_form_sancion" placeholder="TOTAL IMPORTE" disabled >
                        </div>
                        <div class="form-group col-6 col-md-6">
                            <label for="total_importe" class="badge badge-primary">Importe Total Bs.</label>
                            <input type="text" class="form-control" name="total_importe" v-model="total_second" placeholder="TOTAL IMPORTE" disabled >
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cQuestionShip">
                        <span class="col-12">¿Antes de finalizar desea añadir mas Embarcaciones?  </span>                        
                        <button class="btn btn-outline-success btn-sm col-6 col-md-2 offset-md-4" value="si" @click="mAddShip">SI</button>
                        <button class="btn btn-outline-danger btn-sm col-6 col-md-2" value="no" @click="mAddShip">NO</button>
                    </div>
                    </transition>
                    <transition name="fade" mode="in-out">
                    <div class="form-row" v-if="cFormAddShip">                
                        <button class="btn btn-outline-info btn-sm col-6 col-md-3 offset-md-3" data-toggle="modal" data-target="#addBoat" @click="callRegister">
                            <font-awesome-icon icon="plus" size="lg" />Añadir Nave
                        </button>  
                        <button class="btn btn-outline-success btn-sm col-6 col-md-3" data-toggle="modal" data-target="#addBoat" @click="callViewBoats" >
                            <font-awesome-icon icon="eye" size="lg" />Naves Asociadas
                        </button>
                    </div>
                    </transition>
                    <br>
                    <div class="form-row">
                        <button class="btn btn-outline-danger col-6 col-md-4 offset-md-2" @click="fBack">
                            <font-awesome-icon icon="chevron-circle-left" size="lg" />
                        </button>
                        <button class="btn btn-outline-primary col-6 col-md-4" :disabled="autorization_send_sancion ? true:false" @click="mValidateForm">
                            Finalizar <font-awesome-icon icon="save" size="lg" />
                        </button>    
                    </div>
                </div>

            </div>

            <!-- end fourth tab -->
            <modal-other-ship-sancion :id-modal="'addBoat'" :banderas="banderas_sancion"  :register="changeRegister" :view="changeBoats" :types_boat="types_boat_sancion"></modal-other-ship-sancion>
            <modal-loading :id-modal="modal_progress_sancion" :title="'Enviando'" :status-send="send_dispatch_sancion" ></modal-loading>
            <modal-report :id-modal-report="modal_report_sancion" :title="modal_rep_title_sancion" :content="modal_rep_content_sancion" :url-r="url_report_sancion" :id-report="id_reporte_sancion" ></modal-report>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');
import modalOtherShipSancion from './modalOtherShipSancion';
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';



export default {
    name:'b-n-register',
    mounted(){
        this.callBandera(),
        this.callNavigate(),
        this.callPropulsion(),
        this.callUfv(),
        // this.callLoadCash(),
        this.callPassenger(),
        this.callTypesShip(),
        this.getToday(),
        this.mCallBoats(),
        this.mCallPortsCaptain()
    },
    data(){
        return {
            capitan_ship_sancion:null,
            type_boat_sancion:null,
            types_boat_sancion:[],
            placeholder_port_sancion:'',
            port_query_sancion:'',
            portsRegisterSancion:[],
            question_add_ship_sancion:true,
            add_ship_form_sancion:false,
            autorization_send_sancion:true,
            send_dispatch_sancion:true,
            is_disabled_sancion:false,
            is_active_step_one_sancion:true,
            is_active_step_two_sancion:false,
            is_active_step_tree_sancion:false,
            is_active_step_fourth_sancion:false,
            date_office_sancion:null,
            date_office_aux_sancion:null,
            bandera_sancion:null,
            banderas_sancion:[],
            navegacion_sancion:null,
            navegaciones_sancion:[],
            navegacion_sub_sancion:[{factor:0}],//
            state_navigation_sub_sancion:false,
            navegaciones_sub_sancion:[],
            propulsion_sancion:[],//
            propulsiones_sancion:[],
            actividad_sancion:[],//
            actividades_nave_sancion:[],
            ufv_sancion:null,
            ufv_date:null,
            c_efectiva_passenger_sancion:false,
            c_efectiva_load_kilo_sancion:false,
            c_efectiva_load_litro_sancion:false,
            c_efectiva_load_rodada_sancion:false,
            c_quantity_sancion:null,
            passenger_view_sancion:false,
            load_cash_view_sancion:false,
            passenger_sancion:null,//
            load_cash_kilo_sancion:null,//
            load_cash_tonelada_sancion:null,
            load_cash_litro_sancion:null,//
            passengers_sancion:[],
            load_cashs_sancion:[],
            total_form_sancion:0,
            factor_trb_sancion:null,
            national_men_sancion:null,
            national_women_sancion:null,
            foreign_men_sancion:null,
            foreign_women_sancion:null,
            type_navigate_sancion:null,
            cut_sancion:0,
            type_ship_sancion:null,
            type_ships_sancion:[],
            register_boat_sancion:false,
            view_boats_sancion:false,
            port_begin_sancion:{
                id:null,
                description:null,
                disabled:false
            },
            port_finish_sancion:{
                id:null,
                description:null,
                disabled:false
            },
            ports_registers_captain_sancion:[],
            port_select_begin_sancion:{id:null, description:null},
            port_select_finish_sancion:{id:null, description:null},
            modal_progress_sancion:'sendDispatchSancion',
            modal_report_sancion:'pdfZarpe',
            modal_rep_title_sancion:'Despacho de Nave con Sancion',
            modal_rep_content_sancion:'',
            url_report_sancion:'pdfZarpe',
            id_reporte_sancion:0,
            load_query_sancion:null,
            loads_type_sancion:[],
            dPlaceLoadSancion:"Carga",
            aux_activity_sancion:[],
            is_dredge_sancion:false,
            job_days_sancion:0,
            date_init_oper_sancion:null,
            date_end_oper_sancion:null,
            date_init_oper_aux_sancion:null,
            date_end_oper_aux_sancion:null,
            penalty_dts:{
                enroll:0,
                number_relapse:0,
                factor_relapse:0,
                id_track:0
            }                
        }
    },
    computed:{
        cQuestionShip(){
            return this.question_add_ship_sancion;
        },
        cFormAddShip(){
            return this.add_ship_form_sancion;
        },
        global_disabled(){
            return this.$store.getters.getDisabled
        },
        boatLocal(){
            return this.$store.getters.getBoatSancion
        },
        changeTrb(){
            return parseFloat(this.boatLocal.trb);
        },
        changeCUT(){
            return this.cut_sancion;
        },
        changeRegister(){
            return this.register_boat_sancion;
        },
        changeBoats(){
            return this.view_boats_sancion;
        },
        total_second(){
            return (parseFloat(this.$store.getters.getTotalDispatchSancion)+parseFloat(this.total_form_sancion));
        },
        cCallShips(){
            return this.$store.getters.getShipsSancion;
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        port_query_sancion(newQuery){
            
            // axios.get(`searchPort/${newQuery}`)
            axios.get(`searchPort/${newQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    
                    this.portsRegisterSancion = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })             
        },
        load_query_sancion(newLoad){
            
            // axios.get(`searchLoad/${newLoad}`)
            axios.get(`searchLoad/${newLoad}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    
                    this.loads_type_sancion = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
        }
    },
    methods:{
        async mSearchEnroll(){
            console.log(this.boatLocal.enrollment)
            if(typeof this.boatLocal.enrollment == 'undefined'){
                this.boatLocal.enrollment=null;
            }

            if(this.boatLocal.enrollment !== null || this.boatLocal.enrollment !== ' ' ){
                let e ={
                    enrollment:this.boatLocal.enrollment
                }
                let values_relapse=await axios.post(`searchRelapse?api_token=${Vue.auth.getToken()}`, qs.stringify(e));    
                this.penalty_dts.enroll=values_relapse.data[0].enroll;
                this.penalty_dts.number_relapse=values_relapse.data[0].n_relapse;
                this.penalty_dts.factor_relapse=values_relapse.data[0].f_relapse;
                this.penalty_dts.id_track=values_relapse.data[0].id_track;
                this.calculateForm();
            }else{
                toastr.warning('Indique la matricula de la nave', 'Advertencia');
            }
        },
        mSelectLoad(data){            
            
            this.type_ship_sancion=data.id_master;
            this.actividad_sancion.id=data.id;
            this.actividad_sancion.detail=data.detail;
            this.actividad_sancion.factor=data.factor;
            this.aux_activity_sancion.activity=data.master_detail;
            this.aux_activity_sancion.service=data.detail;
            this.viewForm(data.unit_measurement)
            this.calculateForm();
        },
        mSelectedPort(data){
            // console.log(data)

            if(!this.port_begin_sancion.disabled){
                this.port_select_begin_sancion.id=data.port;
                this.port_select_begin_sancion.description=data.portDetail;
            }

            if(!this.port_finish_sancion.disabled){
                this.port_select_finish_sancion.id=data.port;
                this.port_select_finish_sancion.description=data.portDetail;
            }

        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            this.date_office_sancion=today.getFullYear()+'-'+mes+'-'+dia;
            
        },
        mAddShip(event){
            switch(event.target.value){
                case 'no':
                    this.question_add_ship_sancion=false;
                    this.add_ship_form_sancion=false;
                    this.autorization_send_sancion=false;
                break;

                case 'si':
                    this.question_add_ship_sancion=false;
                    this.add_ship_form_sancion=true;
                    this.autorization_send_sancion=false;
                    this.callRegister();
                    $('#addBoat').modal('show');
                break;
            }
        },
        progressModal(){
            $('#'+this.modal_progress_sancion).modal('show');
        },
        closeProgressModal(){
            $('#'+this.modal_progress_sancion).modal('hide');
        },
        mModalReportShow(){
            $('#'+this.modal_report_sancion).modal('show');
        },
        mUpdateShips(){            
            this.$store.dispatch('updateShipSancion');
        },
        callRegister(){
            this.register_boat_sancion=true;
            this.view_boats_sancion=false;
        },
        callViewBoats(){
            
            this.register_boat_sancion=false;
            this.view_boats_sancion=true;
            this.mUpdateShips();
        },
        callTypesShip(){
            this.type_services=null;
            // axios.get('ships/servicionave?api_token='+Vue.auth.getToken())
            // axios.get(`ships/servicionave`)
            axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_ships_sancion=res.data
            })
        },
        codeToken(){
            return `${Math.random(0).toString(36).substr(2)}${Math.random(0).toString(36).substr(2)}${Math.random(0).toString(36).substr(2)}`;
        },
        mValidateForm(){
            let v=0;

            if( !(this.changeTrb > parseFloat(this.boatLocal.trn) ) ){
                v++
                toastr.error('El TRN NO puede ser mayor TRB', 'Error');
            }

            if( (this.port_select_begin_sancion.description ===null && this.port_begin_sancion.disabled) || ( this.port_begin_sancion.disabled===false && this.port_query_sancion==='') ){
                v++
                toastr.error('Debe indicar el puerto de origen', 'Error');
            }

            if(this.is_dredge_sancion){
                if( !(this.job_days_sancion>0) ){
                    toastr.error('Debe indicar los dias que efectuara el trabajo', 'Error');
                    v++;
                }

                let adi=this.date_init_oper_aux_sancion.split('T');
                this.date_init_oper_sancion=adi[0];

                if( this.date_init_oper_sancion === null || !(this.date_init_oper_sancion.length === 10) ){
                    toastr.error('La fecha de Inicio de Operacion es incorrecta', 'Error');
                    v++;
                }

                let ade=this.date_end_oper_aux_sancion.split('T');
                this.date_end_oper_sancion=ade[0];

                if( this.date_end_oper_sancion === null || !(this.date_end_oper_sancion.length === 10) ){
                    toastr.error('La fecha de Conclusion de Operacion es incorrecta', 'Error');
                    v++;
                }

            }
            // date_office_sancion y date_office_aux_sancion

            let dof=this.date_office_sancion.split('T');
                this.date_office_aux_sancion=dof[0];

            if( this.date_office_aux_sancion === null || !(this.date_office_aux_sancion.length === 10) ){
                toastr.error(`La fecha de ${this.type_navigate_sancion} es incorrecta`, 'Error');
                v++;
            }

            if( (this.port_select_finish_sancion.description === null && this.port_finish_sancion.disabled) || ( this.port_finish_sancion.disabled===false && this.port_query_sancion==='') ){
                v++
                toastr.error('DEBE INDICAR EL PUERTO DE DESTINO', 'Error');
            }

            if( v===0 ){
                this.sendRegister();
            }
        },
        sendRegister() {            
            
            // console.log(qs.stringify(param));
            if(this.total_form_sancion && this.boatLocal.name_boat && (this.boatLocal.enrollment || this.boatLocal.enrollment_old) && this.actividad_sancion.factor && this.capitan_ship_sancion ){
                let token=this.codeToken();
                let description_load_aux;
                let c_quantity_aux=this.c_quantity_sancion ? this.c_quantity_sancion:0;    
                if(this.c_efectiva_load_rodada_sancion){                    
                    description_load_aux=this.load_query_sancion;
                }else{
                    description_load_aux=this.load_query_sancion ? this.load_query_sancion : '';
                }
                let shipMaster=[{
                    id_boat:this.boatLocal.id ? parseInt(this.boatLocal.id) : 0,
                    enrollment:this.boatLocal.enrollment ? this.boatLocal.enrollment: this.boatLocal.enrollment_old,
                    name_boat:this.boatLocal.name_boat,
                    trn:parseFloat(this.boatLocal.trn),
                    trb:parseFloat(this.boatLocal.trb),
                    detail_boat:this.boatLocal.detail_boat ? this.boatLocal.detail_boat:this.type_boat_sancion,
                    detail_propulsion:this.boatLocal.detail_propulsion ? this.boatLocal.detail_propulsion:this.propulsion_sancion.detail,
                    factor_propulsion:this.boatLocal.factor_propulsion ? parseFloat(this.boatLocal.factor_propulsion) : parseFloat(this.propulsion_sancion.factor),
                    factor_navigate:parseFloat(this.navegacion_sub_sancion.factor),
                    factor_activity:parseFloat(this.actividad_sancion.factor),
                    service:parseInt(this.actividad_sancion.id),
                    type_service:this.actividad_sancion.detail,
                    tarifa:parseFloat(this.total_form_sancion),
                    kilos:this.load_cash_kilo_sancion ? parseFloat(this.load_cash_kilo_sancion):0,
                    tonelada:this.load_cash_tonelada_sancion ? parseFloat(this.load_cash_tonelada_sancion):0,
                    litros:this.load_cash_litro_sancion ? parseFloat(this.load_cash_litro_sancion):0,
                    national_man:this.national_men_sancion ? parseInt(this.national_men_sancion):0,
                    national_woman:this.national_women_sancion ? parseInt(this.national_women_sancion):0,
                    foreign_man:this.foreign_men_sancion ? parseInt(this.foreign_men_sancion):0,
                    foreign_woman:this.foreign_women_sancion ? parseInt(this.foreign_women_sancion):0,                
                    description_load:description_load_aux,
                    flag:this.boatLocal.flag ? parseInt(this.boatLocal.flag) : parseInt(this.bandera_sancion.id),
                    flag_boat:this.boatLocal.flag_boat ? this.boatLocal.flag_boat:this.bandera_sancion.detail,
                    type:'p',
                    type_sancion:'M',
                    number_relapse:this.penalty_dts.number_relapse,
                    factor_relapse:this.penalty_dts.factor_relapse,
                    id_track:this.penalty_dts.id_track,
                    quantity:c_quantity_aux
                }]
                
                for(let key in this.cCallShips){
                    shipMaster.push(this.cCallShips[key]);
                }

                
                const headMast={                    
                    dispatch_t:this.navegacion_sancion.detail,
                    operation:parseInt(this.navegacion_sub_sancion.id),
                    type_operation:this.navegacion_sub_sancion.detail,
                    capitan_port:'',
                    capitan_id:0,
                    capitan_ship:this.capitan_ship_sancion,
                    port_begin:this.port_begin_sancion.disabled ? this.port_select_begin_sancion.id:0,
                    port_begin_des:this.port_begin_sancion.disabled ? this.port_select_begin_sancion.description:this.port_query_sancion,
                    port_finish:this.port_finish_sancion.disabled ? this.port_select_finish_sancion.id:0,
                    port_finish_des:this.port_finish_sancion.disabled ? this.port_select_finish_sancion.description:this.port_query_sancion,
                    location:0,
                    location_des:'',
                    date_operation:this.date_office_aux_sancion,
                    job_days:this.job_days_sancion,
                    date_init_oper:this.date_init_oper_sancion,
                    date_end_oper:this.date_end_oper_sancion,
                    token_s: token,
                    type_dispatch:'M',
                    ufv:this.ufv_sancion
                }
                let param={
                    headDispatch:JSON.stringify(headMast),
                    bodyDispatch:JSON.stringify(shipMaster)
                }
                
                                
                let message = {
                    title: `Sancion por NO solicitar de Despacho de Nave`,
                    body: `¿Desea registrar la sancion de la Nave o Artefacto Naval llamada <b>${this.boatLocal.name_boat}</b>?`
                };

                let npr=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

                npr.then((msg) =>{
                if(msg){
                    this.progressModal();
                    
                    // axios.post(`insertDispatch`, 
                    axios.post(`insertDispatch?api_token=${Vue.auth.getToken()}`, 
                                    qs.stringify(param))
                        .then(res=>{
                            //#hacer 
                            
                            setTimeout(()=>{
                                this.closeProgressModal();
                                this.modal_rep_content_sancion=res.data[0].respuesta;
                                this.id_reporte_sancion=res.data[1].id_rep;
                                if(this.id_reporte_sancion!==0){
                                    this.question_add_ship_sancion=true;
                                    this.add_ship_form_sancion=false;
                                    this.autorization_send_sancion=false;
                                    
                                    this.c_efectiva_passenger_sancion=false;
                                    this.c_efectiva_load_kilo_sancion=false;
                                    this.c_efectiva_load_litro_sancion=false;
                                    this.c_efectiva_load_rodada_sancion=false;

                                    this.c_quantity_sancion=null;

                                    this.is_active_step_fourth_sancion=false;
                                    this.is_active_step_tree_sancion=false;
                                    this.is_active_step_two_sancion=false;
                                    this.is_active_step_one_sancion=true;
                                    this.autorization_send_sancion=true;
                                    this.$store.dispatch('deleteBoatSancion',true);
                                    // this.$store.dispatch('changeDisabled',false);
                                    this.$store.dispatch('refreshShipSancion',true);
                                }
                                // this.mResetForm();                  
                                this.mModalReportShow();
                            }, 2000);
                            
                        }).catch(error => {
                            console.log(error)
                        })
                    }else{
                        console.error('No se registro el despacho de la nave')
                    }
                })
            }else{
                toastr.warning('Verifique que los campos esten completos ','Advertencia');
            }
        },
        mResetForm(){
            this.port_select_begin_sancion.id=null;
            this.port_select_begin_sancion.description=null;
            this.port_select_finish_sancion.id=null;
            this.port_select_finish_sancion.description=null;
            this.port_query_sancion='';
        },
        calcCUT(){
            let fact_a=0.1;
            let fact_b=2;
            let fact_c=1.8;
            let fact_d=2.3;
            this.cut_sancion=fact_c/(fact_d*(1+fact_a*Math.pow(this.changeTrb, (1/fact_b) )));
        },
        callBandera(){
            // axios.get(`flags`)
            axios.get(`flags?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.banderas_sancion=res.data
            })
        },
        mCallBoats(){
            // axios.get(`boats`)
            axios.get(`boats?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.types_boat_sancion=res.data
            })
        },
        async mCallPortsCaptain(){
            // let cr=await axios.get(`portsCaptain/${this.cDtsUser.portId}`);
            let cr=await axios.get(`portsCaptain/${this.cDtsUser.portId}?api_token=${Vue.auth.getToken()}`);
            this.ports_registers_captain_sancion=[];
            // console.log(cr);
            let ar=cr.data;
            ar.forEach( (e,index) => {
                let ap={
                    id:e.id,
                    description:e.description,
                    code_aux:index
                }
                this.ports_registers_captain_sancion.push(ap);
            });            
        },
        callNavigate(){
            // axios.get('navigation')
            axios.get(`navigation?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                
                this.navegaciones_sancion=res.data
            })
        },
        callPropulsion(){
            let propulsion_sancion={
                parent:4
            }
            // axios.post('submenu', qs.stringify(propulsion_sancion))
            axios.post(`submenu?api_token=${Vue.auth.getToken()}`, qs.stringify(propulsion_sancion))
            .then(res => {                
                this.propulsiones_sancion=res.data
            })
        },
        callService(){
            // axios.get('submenus/'+this.type_ship_sancion)
            axios.get(`submenus/${this.type_ship_sancion}?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.actividades_nave_sancion=res.data
            })
        },
        callUfv(){
            // axios.get('ufv_sancion?api_token='+Vue.auth.getToken())
            // axios.get(`ufv_sancion`)
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                this.ufv_sancion=res.data[0].value;
                this.ufv_date=res.data[0].date;
                this.$store.dispatch('addUFV', res.data[0].value);
                this.calculateForm();
            })
        },
        callNavDet(){
            
                this.findValue(this.navegacion_sancion.id);
                // axios.post('submenu',qs.stringify({parent:this.navegacion_sancion.id}))
                let sendNavigate={
                    parent:this.navegacion_sancion.id,
                    captain:this.cDtsUser.portId,
                    type:'E'
                }
                axios.post(`submenu?api_token=${Vue.auth.getToken()}`,qs.stringify(sendNavigate))
                .then(res => {                
                    this.navegaciones_sub_sancion=res.data
                    this.state_navigation_sub_sancion=true

                })
            
        },
        findValue(id){
            // for(let i=0; i<this.navegaciones_sancion.length; i++){
            //     this.navegaciones_sancion
            // }
            for(let key in this.navegaciones_sancion){
                if(this.navegaciones_sancion[key].id === id){
                    this.type_navigate_sancion=this.navegaciones_sancion[key].detail.toLowerCase();                    
                }
            }

            switch(this.type_navigate_sancion){
                case 'zarpe':
                    // this.port_begin_sancion.id=this.cDtsUser.portId;
                    // this.port_begin_sancion.description=this.cDtsUser.name_port;
                    this.port_begin_sancion.disabled=true;

                    // this.port_select_finish_sancion.id=null;
                    // this.port_select_finish_sancion.description=null;
                    
                    this.placeholder_port_sancion='PUERTO ATRAQUE';
                    
                    this.port_finish_sancion.id=null;
                    this.port_finish_sancion.description=null;
                    this.port_finish_sancion.disabled=false;
                break;

                case 'atraque':
                    // this.port_finish_sancion.id=this.cDtsUser.portId;
                    // this.port_finish_sancion.description=this.cDtsUser.name_port;
                    this.port_finish_sancion.disabled=true;

                    this.placeholder_port_sancion='PUERTO ZARPE';

                    // this.port_select_begin_sancion.id=null;
                    // this.port_select_begin_sancion.description=null;

                    this.port_begin_sancion.id=null;
                    this.port_begin_sancion.description=null;
                    this.port_begin_sancion.disabled=false;
                break;
            }
        },
        callPassenger(){
            // axios.post(`submenu`,qs.stringify({parent:5}))
            axios.post(`submenu?api_token=${Vue.auth.getToken()}`,qs.stringify({parent:5}))
            .then(res => {                
                this.passengers_sancion=res.data
            })
        },
        viewForm(data){
            switch(data){
                case 'C':
                    this.c_efectiva_passenger_sancion=false;
                    this.c_efectiva_load_kilo_sancion=true;
                    this.c_efectiva_load_litro_sancion=false;
                    this.c_efectiva_load_rodada_sancion=false;
                break;
                case 'L':
                    this.c_efectiva_passenger_sancion=false;
                    this.c_efectiva_load_kilo_sancion=false;
                    this.c_efectiva_load_litro_sancion=true;
                    this.c_efectiva_load_rodada_sancion=false;
                break;
                case 'P':
                    this.c_efectiva_passenger_sancion=true;
                    this.c_efectiva_load_kilo_sancion=false;
                    this.c_efectiva_load_litro_sancion=false;
                    this.c_efectiva_load_rodada_sancion=false;
                break;
                case 'R':
                    this.c_efectiva_passenger_sancion=false;
                    this.c_efectiva_load_rodada_sancion=true;
                    this.c_efectiva_load_kilo_sancion=true;
                    this.c_efectiva_load_litro_sancion=false;
                break;
            }
            
        },
        calculateForm(){
            // MD=fmd*r*U*(1+N*P*A*T*C)
            // MD: Tarifa a cobrarse por la multa por omisión de solicitud de despacho de nave.
            // fmd: Factor de multa por omisión de solicitud de despacho, cuyo valor actual es 1.1.
            // r: Factor de multa por reincidencia en la omisión de solicitud de despacho de nave. Su valor inicial es 1. En la primera reincidencia será de 1.5. En las sucesivas reincidencias se incrementará 0.5 por cada una.
            // U: Valor en Bs. (moneda de curso legal del EPB) de la Unidad de Fomento a la Vivienda (UFV) que será aplicado del 1 de enero al 31 de diciembre de la gestión correspondiente.
            // N: Coeficiente del tipo de Navegación, definido en la Tabla 9.1 del Artículo 9.
            // P: Coeficiente del tipo de Propulsión de la nave, definido en la Tabla 9.2 del Artículo 9.
            // A: Coeficiente de la Actividad Náutica a ser desarrollada por la nave que solicita el servicio de despacho, definido en la Tabla 9.3 del Artículo 9.
            // T: Tonelaje de Registro Bruto de la nave (TRB), señalado en su Certificado expedido por la Autoridad Competente del Transporte Acuático.
            // C: Costo Unitario aplicado al Tonelaje de Registro Bruto, el cual se calcula con el procedimiento señalado en el Artículo 8.

            // this.mSearchEnroll();
            
            let factors={
                    navigate:this.navegacion_sub_sancion.factor,
                    activity:this.actividad_sancion.factor
            }
            this.$store.dispatch('addFactorSancion', factors);

            let result=0;
            this.calcCUT();
            
            if(this.navegacion_sub_sancion && (this.propulsion_sancion || this.boatLocal.factor_propulsion) && this.actividad_sancion.factor && this.changeCUT){
                        
                    let factPropulsion;
                        
                    factPropulsion= this.boatLocal.factor_propulsion ? this.boatLocal.factor_propulsion : this.propulsion_sancion.factor;
                    
                    // MD=fmd*r*U*(1+N*P*A*T*C)
                    result= 1.1 * this.penalty_dts.factor_relapse * this.ufv_sancion * (1 + this.navegacion_sub_sancion.factor * factPropulsion * this.actividad_sancion.factor *this.boatLocal.trb * this.changeCUT);

                    let aux_result=result.toFixed(2);
                    
                    let number_enter=Math.trunc(aux_result);
                    let number_decimal=Number((aux_result-number_enter).toFixed(2));

                    if(number_decimal===0.50){
                        result=aux_result;
                    
                    }else if(number_decimal>0.50){
                        result=number_enter+1;
                    
                    }else{                
                        result=number_enter;                    
                    }
                    this.total_form_sancion=result;
                    this.mUpdateShips();
                        // toastr.success(''+this.total_form_sancion+'','Importe Aprox.')
                }else{
                        console.log('aun faltan datos por confirmar en modo dragado');
                        // toastr.error('Aun falta llenar campos', 'Alerta');
                }
            
        },
        fNext(){
            switch(true){
                case this.is_active_step_one_sancion:
                    this.is_active_step_one_sancion=false;
                    this.is_active_step_two_sancion=true;
                break;

                case this.is_active_step_two_sancion:
                    this.is_active_step_two_sancion=false;
                    this.is_active_step_tree_sancion=true;
                break;

                case this.is_active_step_tree_sancion:
                    this.is_active_step_tree_sancion=false;
                    this.is_active_step_fourth_sancion=true;
                break;
            }
        },
        fBack(){            
            switch(true){
                case this.is_active_step_two_sancion:
                    this.is_active_step_two_sancion=false;
                    this.is_active_step_one_sancion=true;
                break;

                case this.is_active_step_tree_sancion:
                    this.is_active_step_tree_sancion=false;
                    this.is_active_step_two_sancion=true;
                break;

                case this.is_active_step_fourth_sancion:
                    this.is_active_step_fourth_sancion=false;
                    this.is_active_step_tree_sancion=true;
                break;
            }
        },
        calcToneladaKilo(){
            this.load_cash_kilo_sancion=this.load_cash_tonelada_sancion*1000;
        },
        calcKiloTonelada(){
            this.load_cash_tonelada_sancion=this.load_cash_kilo_sancion/1000;
        }
    },
    components:{
        'modal-other-ship-sancion':modalOtherShipSancion,
        'modal-loading':modalLoading,
        'modal-report':modalReport
    }
}
</script>




// WEBPACK FOOTER //
// src/components/cotizacion/boatNotRegisterSancion.vue